(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  // Mirrors Shopify's money_format so JS prices match Liquid prices.
  const money = (cents) => {
    const fmt = window.moneyFormat || 'R {{amount}}';
    const n = Number(cents) / 100;
    const sep = (num, dec, th, ds) => {
      const [i, d] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: sep(n, 2, ',', '.'),
      amount_no_decimals: sep(n, 0, ',', '.'),
      amount_with_comma_separator: sep(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: sep(n, 0, '.', ','),
      amount_with_space_separator: sep(n, 2, ' ', ','),
      amount_no_decimals_with_space_separator: sep(n, 0, ' ', ','),
      amount_with_apostrophe_separator: sep(n, 2, "'", '.')
    }[k] || sep(n, 2, ',', '.'))).replace(/<[^>]*>/g, '');
  };

  /* ---------- toast ---------- */
  const toast = $('.toast');
  let toastTimer;
  function showToast(html, isError) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.classList.toggle('toast--err', !!isError);
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-on'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.classList.remove('is-on');
      setTimeout(() => (toast.hidden = true), 300);
    }, 3800);
  }

  function setBagCount(n) {
    $$('.js-bag-count').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  window.fifthNote = { money, showToast, setBagCount };

  /* ---------- mobile drawer ---------- */
  const drawer = $('.js-drawer');
  if (drawer) {
    drawer.addEventListener('toggle', () => {
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.open) {
        drawer.open = false;
        $('summary', drawer).focus();
      }
    });
  }

  /* ---------- box style tabs ---------- */
  $$('.nob').forEach((sec) => {
    const tabs = $$('.js-tier', sec);
    const lid = $('.js-lid', sec);
    const line = $('.js-lid-line', sec);
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (lid) lid.className = 'lid lid--' + tab.dataset.tier + ' js-lid';
      if (line) line.textContent = tab.dataset.line || '';
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        const dir = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (e.key === 'Home') { e.preventDefault(); select(tabs[0], true); }
        if (e.key === 'End') { e.preventDefault(); select(tabs[tabs.length - 1], true); }
        if (dir) { e.preventDefault(); select(tabs[(i + dir + tabs.length) % tabs.length], true); }
      });
    });
  });

  /* ---------- product page ---------- */
  const pdp = $('.pdp');
  if (pdp) {
    const form = $('.js-product-form', pdp);
    const variants = JSON.parse(($('.js-variants', pdp) || {}).textContent || '[]');
    const idInput = $('.js-variant-id', pdp);
    const addBtn = $('.js-add', pdp);
    const priceEl = $('.js-price', pdp);
    const stickyPrice = $('.js-sticky-price', pdp);
    const stickyAdd = $('.js-sticky-add', pdp);
    const sticky = $('.js-sticky', pdp);
    const strings = window.themeStrings || {};

    const showMedia = (id) => {
      if (!id) return;
      $$('.js-slide', pdp).forEach((s) => (s.hidden = String(s.dataset.mediaId) !== String(id)));
      $$('.js-thumb', pdp).forEach((t) => t.classList.toggle('is-active', String(t.dataset.mediaId) === String(id)));
    };
    $$('.js-thumb', pdp).forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.mediaId)));
    const firstVisible = $('.js-slide:not([hidden])', pdp);
    if (firstVisible) showMedia(firstVisible.dataset.mediaId);

    const options = $$('.js-option', pdp);
    const onOptionChange = () => {
      const chosen = [];
      options.filter((o) => o.checked).forEach((o) => (chosen[o.dataset.index] = o.value));
      const v = variants.find((v) => v.options.every((opt, i) => opt === chosen[i]));
      const labelSold = addBtn ? addBtn.dataset.sold || 'Sold out' : '';
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      const cmp = $('.js-compare', pdp);
      if (cmp) cmp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.add : labelSold;
      }
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (v.featured_media) showMedia(v.featured_media.id);
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    };
    if (addBtn) {
      addBtn.dataset.add = addBtn.dataset.add || 'Add to bag';
      addBtn.dataset.sold = 'Sold out';
    }
    options.forEach((o) => o.addEventListener('change', onOptionChange));

    $$('.js-qty', pdp).forEach((b) =>
      b.addEventListener('click', () => {
        const input = b.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
      })
    );

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        const label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.setAttribute('aria-busy', 'true');
        try {
          const fd = new FormData(form);
          const res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || strings.error);
          const cart = await fetch(window.routes.cart_url + '.js').then((r) => r.json());
          setBagCount(cart.item_count);
          showToast(`<span>${strings.added || 'Added to your bag'}</span><a href="${window.routes.cart_url}">View bag</a>`);
        } catch (err) {
          showToast(err.message || strings.error, true);
        } finally {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-busy');
          addBtn.textContent = label;
        }
      });
    }

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(addBtn);
      stickyAdd && stickyAdd.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }
  }

  /* ---------- related products ---------- */
  const related = $('.js-related');
  if (related && related.dataset.url && !related.children.length) {
    fetch(related.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.js-related');
        if (inner && inner.innerHTML.trim()) related.innerHTML = inner.innerHTML;
      })
      .catch(() => {});
  }

  /* ---------- collection sort ---------- */
  $$('.js-autosubmit').forEach((s) => s.addEventListener('change', () => s.form.submit()));
})();

/* ---------- 5th Note Club ---------- */
document.querySelectorAll('.js-club').forEach((form) => {
  const steps = [...form.querySelectorAll('.js-step')];
  const label = form.querySelector('.js-step-label');
  const bar = form.querySelector('.js-bar');
  const recipient = form.querySelector('.js-recipient');
  let current = 0;

  const values = (name) => [...form.querySelectorAll(`[name="${name}"]:checked`)].map((i) => i.value);
  const val = (name) => ((form.elements[name] && form.elements[name].value) || '').trim();

  form.querySelectorAll('[name="for"]').forEach((r) =>
    r.addEventListener('change', () => {
      const other = val('for') === 'Someone else' || values('for')[0] === 'Someone else';
      recipient.hidden = !other;
      if (other) recipient.querySelector('input').focus();
    })
  );

  const show = (i) => {
    steps.forEach((s, n) => (s.hidden = n !== i));
    current = i;
    label.textContent = `Step ${i + 1} of ${steps.length}`;
    bar.style.width = `${((i + 1) / steps.length) * 100}%`;
    const legend = steps[i].querySelector('legend');
    const modal = form.closest('dialog');
    if (modal) modal.querySelector('.club-modal__panel').scrollTo({ top: 0, behavior: 'smooth' });
    else form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (legend) { legend.tabIndex = -1; legend.focus({ preventScroll: true }); }
  };

  const fail = (step, msg, field) => {
    const err = step.querySelector('.js-err');
    err.textContent = msg;
    err.hidden = false;
    if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
    return false;
  };

  const budgetInput = form.querySelector('.js-budget');
  const budgetValue = () => Number(String(budgetInput.value).replace(/[^\d.]/g, ''));
  const budgetProblem = () => {
    const v = budgetValue(), min = Number(budgetInput.dataset.min), max = Number(budgetInput.dataset.max), unit = Number(budgetInput.dataset.unit) || 1;
    if (!v) return 'Type your monthly budget.';
    if (v < min) return `The lowest monthly budget is R${min}.`;
    if (v > max) return `The highest monthly budget is R${max}.`;
    if (v % unit !== 0) return `Use an amount in steps of R${unit}, e.g. R${Math.round(v / unit) * unit}.`;
    return '';
  };
  const kindBox = form.querySelector('.js-kind');
  const genuineMin = Number(kindBox.dataset.genuineMin) || 0;
  const kindNote = form.querySelector('.js-kind-note');
  const kind = () => (form.querySelector('[name="kind"]:checked') || {}).value || '';
  const syncKind = () => {
    const b = budgetValue();
    const locked = !b || b < genuineMin;
    form.querySelectorAll('.js-needs-genuine input').forEach((r) => {
      if (locked && r.checked) r.checked = false;
      r.disabled = locked;
      r.closest('label').classList.toggle('is-off', locked);
    });
    kindNote.hidden = !(b && b < genuineMin);
  };
  const check = (i) => {
    const step = steps[i];
    step.querySelectorAll('[aria-invalid]').forEach((f) => f.removeAttribute('aria-invalid'));
    step.querySelector('.js-err').hidden = true;
    if (i === 0) {
      if (!val('name')) return fail(step, 'Add your name so we know who you are.', form.elements.name);
      if (!/^\S+@\S+\.\S+$/.test(val('email'))) return fail(step, 'Add a valid email so we can reach you.', form.elements.email);
      if (values('for')[0] === 'Someone else' && !val('recipient')) return fail(step, "Add the name of the person you're buying for.", form.elements.recipient);
    }
    if (i === 1 && !values('families').length && !values('notes').length && !val('other_notes')) {
      return fail(step, 'Pick at least one scent family or note, so we know what to send.');
    }
    if (i === 2 && budgetProblem()) return fail(step, budgetProblem(), budgetInput);
    if (i === 2 && !kind()) return fail(step, 'Choose dupes, genuine colognes or both.');
    if (i === 2 && kind() !== 'Dupes' && budgetValue() < genuineMin) return fail(step, `Genuine colognes need a monthly budget of at least R${genuineMin}.`, budgetInput);
    return true;
  };

  /* ----- Fragrance DNA: loved fragrances, trait limit, picks from the DNA engine ----- */
  const DNA = window.FifthDNA;
  let picks = [];
  let lastCustomer = null;
  const loved = new Map(); // handle -> title
  const lovedInput = form.querySelector('.js-loved-input');
  const lovedChips = form.querySelector('.js-loved-chips');
  const renderLoved = () => {
    lovedChips.innerHTML = '';
    loved.forEach((title, handle) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'loved__chip';
      b.setAttribute('aria-label', 'Remove ' + title);
      b.textContent = title + ' \u00d7';
      b.addEventListener('click', () => { loved.delete(handle); renderLoved(); });
      lovedChips.appendChild(b);
    });
  };
  if (lovedInput && DNA) DNA.typeahead(lovedInput, (p) => { loved.set(p.handle, (p.vendor ? p.vendor + ' ' : '') + p.title); renderLoved(); });
  if (lovedInput) lovedInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') e.preventDefault(); });
  form.querySelectorAll('.js-traits input').forEach((cb) => cb.addEventListener('change', () => {
    if (form.querySelectorAll('.js-traits input:checked').length > 3) { cb.checked = false; }
  }));
  // start loading the catalogue as soon as the questionnaire is in use
  form.addEventListener('focusin', () => { if (DNA) DNA.loadCatalogue().catch(() => {}); }, { once: true });

  const gatherAnswers = () => ({
    families: values('families'), notes: values('notes'), other_notes: val('other_notes'), hate: values('hate'),
    avoid: val('avoid'), occasions: values('occasions'), strength: values('strength')[0] || '', lasting: values('lasting')[0] || '',
    traits: values('traits'), adventure: Number((form.elements.adventure || {}).value || 5), loved: Array.from(loved.keys()),
    budget: budgetValue(), kind: kind()
  });

  let picksLoading = null;
  let loadId = 0;
  const loadPicks = () => (picksLoading = runPicks(++loadId).finally(() => { picksLoading = null; }));
  const runPicks = async (id) => {
    const box = form.querySelector('.js-picks');
    const intro = form.querySelector('.js-picks-intro');
    form.querySelector('.js-picks-wrap').hidden = false;
    intro.textContent = '';
    box.innerHTML = '<p class="picks__status">Comparing your Fragrance DNA with our catalogue\u2026</p>';
    if (!DNA) { box.innerHTML = ''; return; }
    let cat;
    try { cat = await DNA.loadCatalogue(); } catch (_) { cat = null; }
    if (id !== loadId) return; // a newer budget was typed while this one loaded
    if (!cat) { box.innerHTML = ''; intro.textContent = 'We couldn\u2019t load our catalogue just now. Join anyway and your curator will hand-pick your box.'; return; }
    const { c } = DNA.saveAnswers(gatherAnswers(), cat);
    lastCustomer = c;
    const budget = budgetValue();
    const rec = DNA.recommend(cat, c, { budget, kind: kind(), excludeHandles: Array.from(loved.keys()), max: 7 });
    picks = rec.picks.map((x) => ({ p: x.product, price: x.product.price, variant: { id: x.product.variant }, slot: x.slot, pct: x.pct, reason: x.reason, label: x.label }));
    box.innerHTML = '';
    const fmt = (n) => (window.fifthNote ? window.fifthNote.money(Math.round(n * 100)) : 'R' + n).replace(/[.,]00(?!\d)/, '');
    if (!picks.length) {
      intro.textContent = `We analysed ${rec.analysed.toLocaleString('en-ZA')} fragrances, but none fit your answers up to ${fmt(budget)} yet. Join anyway and your curator will hand-pick your first box.`;
      return;
    }
    intro.textContent = `We analysed ${rec.analysed.toLocaleString('en-ZA')} fragrances against your Fragrance DNA. These are your strongest ${picks.length} up to ${fmt(budget)}. ${DNA.describe(c)}`;
    picks.forEach((x) => box.appendChild(pickCard(x, fmt)));
    const wrap = form.querySelector('.js-picks-wrap');
    if (wrap.getBoundingClientRect().top > window.innerHeight * 0.6) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    DNA.aiReasons(c, rec.picks).then((r) => {
      if (!r || id !== loadId) return;
      box.querySelectorAll('[data-handle]').forEach((el) => { const t = r[el.dataset.handle]; if (t) el.querySelector('.pick__why').textContent = t; });
    });
  };

  const pickCard = (x, fmt) => {
    const card = document.createElement('article');
    card.className = 'pick';
    card.dataset.handle = x.p.handle;
    const top = document.createElement('p'); top.className = 'pick__slot';
    const lab = document.createElement('span'); lab.textContent = x.label; top.appendChild(lab);
    const pct = document.createElement('strong'); pct.textContent = x.pct + '% match'; top.appendChild(pct);
    card.appendChild(top);
    if (x.p.image) {
      const im = document.createElement('img');
      im.src = x.p.image; im.alt = x.p.title; im.loading = 'lazy'; im.width = 400; im.height = 500;
      card.appendChild(im);
    } else { const ph = document.createElement('div'); ph.className = 'pick__ph'; card.appendChild(ph); }
    const info = document.createElement('div'); info.className = 'pick__info';
    const v = document.createElement('p'); v.className = 'pick__vendor'; v.textContent = x.p.vendor || ''; info.appendChild(v);
    const t = document.createElement('p'); t.className = 'pick__title'; t.textContent = x.p.title; info.appendChild(t);
    const pr = document.createElement('p'); pr.className = 'pick__price'; pr.textContent = fmt(x.price); info.appendChild(pr);
    const why = document.createElement('p'); why.className = 'pick__why'; why.textContent = x.reason; info.appendChild(why);
    card.appendChild(info);
    return card;
  };

  const goNext = async () => {
    if (!check(current)) return;
    show(current + 1);
  };
  form.querySelectorAll('.js-next').forEach((b) => b.addEventListener('click', goNext));
  let typing;
  budgetInput.addEventListener('input', () => {
    clearTimeout(typing);
    steps[2].querySelector('.js-err').hidden = true;
    budgetInput.removeAttribute('aria-invalid');
    syncKind();
    typing = setTimeout(() => { if (!budgetProblem()) loadPicks(); }, 450);
  });
  syncKind();
  form.querySelectorAll('[name="kind"]').forEach((r) => r.addEventListener('change', () => {
    steps[2].querySelector('.js-err').hidden = true;
    if (!budgetProblem()) loadPicks();
  }));
  budgetInput.addEventListener('blur', () => { const p = budgetProblem(); if (p && budgetInput.value) fail(steps[2], p); });
  form.querySelectorAll('.js-back').forEach((b) => b.addEventListener('click', () => show(current - 1)));
  form.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT' && current < steps.length - 1) {
      e.preventDefault();
      goNext();
    }
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (![0, 1, 2].every((i) => check(i) || (show(i), false))) return;
    if (!picks.length && !form.querySelector('.js-picks').children.length) await loadPicks();
    if (picksLoading) await picksLoading;
    const joinBtn = form.querySelector('.js-join');
    const step = steps[2];
    const budget = budgetValue();
    const budgetText = (window.fifthNote ? window.fifthNote.money(Math.round(budget * 100)) : 'R' + budget).replace(/[.,]00(?!\d)/, '');
    const forOther = values('for')[0] === 'Someone else';
    const member = forOther ? val('recipient') : val('name');

    const answers = {
      member,
      ordered_by: val('name'),
      email: val('email'),
      phone: val('phone'),
      gift: forOther ? 'Yes' : 'No',
      budget: budgetText,
      budget_value: budget,
      kind: kind(),
      families: values('families').join(', '),
      notes: values('notes').join(', '),
      other_notes: val('other_notes'),
      avoid: val('avoid'),
      occasions: values('occasions').join(', '),
      strength: values('strength')[0] || '',
      owns: val('owns'),
      loved: Array.from(loved.values()).join(', '),
      hate: values('hate').join(', '),
      lasting: values('lasting')[0] || '',
      recommended: picks.map((x) => `${x.p.vendor ? x.p.vendor + ' ' : ''}${x.p.title} (${x.pct}% ${x.label})`).join('; '),
      website: val('website'),
      submitted: new Date().toISOString()
    };

    if (answers.website) return; // honeypot filled: a bot, not a person
    if (DNA && lastCustomer) Object.assign(answers, DNA.summaryForSheet(lastCustomer, DNA.load() || {}));
    if (DNA) { const st = DNA.load(); if (st) { st.contact = { member, email: answers.email }; DNA.save(st); } }

    joinBtn.disabled = true;
    joinBtn.setAttribute('aria-busy', 'true');
    joinBtn.textContent = 'Saving your answers…';

    // 1. Private answers sheet (only sent if the URL is set in the theme editor)
    const endpoint = form.dataset.endpoint;
    if (endpoint) {
      try {
        await fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({ ...answers, key: form.dataset.key })
        });
      } catch (_) { /* the order still carries every answer below */ }
    }
    // 2a. Club not taking payments yet: just keep the answers
    if (form.dataset.mode !== 'checkout') {
      if (!endpoint) {
        // No sheet set up: email the answers to the store via Shopify's contact form
        const body = new URLSearchParams({
          form_type: 'contact',
          utf8: '✓',
          'contact[name]': answers.ordered_by,
          'contact[email]': answers.email,
          'contact[phone]': answers.phone,
          'contact[body]': [
            '5th Note Club sign-up',
            'Member: ' + answers.member + (answers.gift === 'Yes' ? ' (gift from ' + answers.ordered_by + ')' : ''),
            'Budget: ' + answers.budget + ' / month',
            'Wants: ' + answers.kind,
            'Our picks: ' + answers.recommended,
            'Families: ' + answers.families,
            'Notes: ' + [answers.notes, answers.other_notes].filter(Boolean).join(', '),
            'Avoid: ' + answers.avoid,
            'Wears it for: ' + answers.occasions,
            'Strength: ' + answers.strength,
            'Owns or loves: ' + answers.owns
          ].join('\n')
        });
        try { await fetch('/contact#contact_form', { method: 'POST', body }); } catch (_) {}
      }
      steps.forEach((s) => (s.hidden = true));
      form.querySelector('.club__progress').hidden = true;
      form.querySelector('.club__bar').hidden = true;
      const done = form.querySelector('.js-done');
      form.querySelector('.js-done-name').textContent = answers.ordered_by.split(' ')[0];
      done.hidden = false;
      done.focus();
      return;
    }

    // 2b. Add the membership to the bag with the answers attached to the order
    const properties = {
      'Member': member,
      'Favourite families': answers.families,
      'Favourite notes': [answers.notes, answers.other_notes].filter(Boolean).join(', '),
      'Avoid': answers.avoid,
      'Wears it for': answers.occasions,
      'Strength': answers.strength,
      'Owns or loves': answers.owns,
      'Monthly budget': budgetText,
      'Wants': kind(),
      'WhatsApp': answers.phone,
      'Our picks': picks.slice(0, 3).map((x) => x.p.title).join(', ')
    };
    if (forOther) properties['Gift from'] = answers.ordered_by;
    Object.keys(properties).forEach((k) => !properties[k] && delete properties[k]);

    try {
      joinBtn.textContent = 'Taking you to payment…';
      // start from an empty bag so an earlier visit can't double the payment
      await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [Object.assign({ id: Number(budgetInput.dataset.variant), quantity: Math.round(budget / (Number(budgetInput.dataset.unit) || 1)), properties }, form.dataset.plan ? { selling_plan: Number(form.dataset.plan) } : {})] })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message);
      window.location.href = form.dataset.checkout;
    } catch (err) {
      joinBtn.disabled = false;
      joinBtn.removeAttribute('aria-busy');
      joinBtn.textContent = form.dataset.joinLabel || 'Continue to payment';
      fail(step, (err && err.message) || "Couldn't start checkout. Try again, or message us on WhatsApp.");
    }
  });
});

/* ---------- Club pop-up from the header tab ---------- */
(() => {
  const modal = document.querySelector('.js-club-modal');
  if (!modal || typeof modal.showModal !== 'function') return; // old browsers follow the link to the club page
  let opener = null;
  const open = (e) => {
    document.querySelectorAll('dialog[open]').forEach((d) => { if (d !== modal) d.close(); });
    if (e) { e.preventDefault(); opener = e.currentTarget; }
    const drawer = document.querySelector('.js-drawer');
    if (drawer && drawer.open) { drawer.open = false; document.body.style.overflow = ''; }
    modal.showModal();
    const first = modal.querySelector('.js-step:not([hidden]) input:not([type=hidden]):not([tabindex="-1"])');
    if (first) first.focus();
  };
  const close = () => modal.close();
  document.querySelectorAll('.js-open-club').forEach((a) => a.addEventListener('click', open));
  modal.querySelector('.js-club-close').addEventListener('click', close);
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  modal.addEventListener('close', () => { if (opener) opener.focus(); });
  if (/[?&]club=open\b/.test(location.search) || location.hash === '#club') open();
})();
